export const appConstant = {
    API_NOT_AVAILABLE: 'APP_API_NOT_AVAILABLE',
    SET_LAST_LOGIN: 'APP_SET_LAST_LOGIN'
};
